module.exports = __webpack_public_path__ + "static/media/file_type_doc_icon.0d2bfd11.svg";